import React, { useCallback, useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Autocomplete } from '@mui/material';
import { Close, Star } from '@mui/icons-material';

import AnimatedText from "components/AnimatedText";
import COLOR from "utils/constants/color";
import Loading from "components/Loading";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import Tag from "components/Tag";
import { chunk, cloneDeep, filter, find, findIndex, get, map, has } from "lodash";
import moment from "moment";
import styled from "styled-components";
import { ANÉCDOTAS_THEMES, AP_THEME, IB_Theme } from "utils/config/reference";
import { Col, Row } from "antd";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { handleUpdateUnits } from "store/booksUnits/thunks";
import BalconCover from "../bookUnits/bookUnitCover";
import Pages from "../bookUnits/pages";

//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
//  -- Components ---------------------
import {
  Button,
  FormControl,
  FormControlLabel,
  IconButton,
  InputLabel,
  
  MenuItem,
  Modal,
  Select,
  Switch,
  TextField,
  Typography,
} from '@mui/material';

import { makeStyles } from '@mui/styles';



















//  -- Constants ----------------------

//  -- Features -----------------------

//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------

const PAGE_CATEGORY = [
  "Other",
  "Entretenimiento",
  "Tecnología",
  "Deportes",
  "Historias",
  "Cultura",
  "Música",
  "Curiosidades",
  "Cine",
  "Fantasía",
  "Realismo",
  "Ciencia ficción",
  "Magia",
  "Espacio",
  "6-8th ",
  "9-10th",
  "11-12th",
];

export const Wrapper = styled.div`
  width: calc(100% + 48px);
  margin-left: -24px;
  padding: 0px 24px;
  justify-content: center;
`;

const FormArea = styled.div`
  overflow: auto;
  margin-top: 10px;
`;
const Note = styled.span`
  color: ${COLOR.black400};
  display: block;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 16px;
`;

const ImageContainer = styled.div`
  height: auto;
  flex: 1;
  padding: 10px 0px;
  padding-bottom: 20px;
`;
const BoxRow = styled.div`
  width: 100%;
  -webkit-flex-direction: row;
  -ms-flex-direction: row;
  flex-direction: row;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  padding: 10px 20px;

  @media (max-width: 768px) {
    display: inherit;
  }
`;

const Column = styled.div`
  width: 23%;
  cursor: pointer;
  margin: 10px;
  position: relative;
  @media (max-width: 768px) {
    width: 93%;
  }
`;

const CoverSecion = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: ${(p) => (p.overflowItem ? "scroll" : "hidden")};
`;

const NewTag = styled.div`
  color: #fff;
  background-color: rgb(211, 51, 49);
  text-transform: uppercase;
  font-weight: 800;
  font-weight: 800;
  width: 60px;
  position: absolute;
  text-align: center;
  top: -22px;
`;

const ModalContent = styled.div`
  left: 50%;
  width: 80vw;
  height:90vh;
  padding: 0px 24px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color:#fff;
  padding:10px;
  overflow: auto;
   @media only screen and (max-width: 600px) {
        width: 90%;
    }
`;
const ModalConfigArea = styled.div`
  //   max-height:75vh;
  //   overflow:auto;
  margin-top: 10px;
  @media only screen and (max-width: 600px) {
    max-height: 75vh;
  }
`;

const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
  // margin-left:5px;
  // margin-top:5px;
`;

const ButtonContanier = styled.div`
  margin-right: 25px;
  position: absolute;
  right: 33px;
  top: 10px;
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: '4px',
  },
}));
const sortUnits = function (a, b) {
  if (Number(a.id) < Number(b.id)) {
    return 1;
  }
  if (Number(a.id) > Number(b.id)) {
    return -1;
  }
  // a must be equal to b
  return 0;
};
const UnitModal = ({
  booksAllList,
  UNIT_DATA,
  selection,
  handleSubmit,
  items,
  selectedItem,
  setSelectedItem,
  pageId,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [bookId, setBookId] = useState("");
  const [displayName, setDisplayName] = useState([]);
  const [editUnit, setEditUnit] = useState(null);
  const [cover, setCover] = useState(null);
  const [unitModal, setUnitModal] = useState(false);
  const classes = useStyles();
  const [pgData, setPgData] = useState(null);
  const [saveModal, setSaveModal] = useState(false);
  const [bookErrors, setErrors] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [deleteToggle, setDeleteToggle] = useState(false);
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const pageLengthById = find(booksAllList, (book) => book.id === bookId)?.pages
    ?.length;

  function filterByPageIdRange(array, pageId) {
    const data = array.filter((item) => {
      const start = Number(item.start);
      const finish = Number(item.finish);

      const isWithinRange = pageId >= start && pageId <= finish;
      return !isWithinRange;
    });
    return data;
  }

  useEffect(() => {
    if (UNIT_DATA) {
      setEditUnit(UNIT_DATA);
      setCover(UNIT_DATA.img);
      const urlParams = new URLSearchParams(window.location.search);
      const hasPageId = urlParams.has("pageId");
      if (hasPageId) {
        setPages(
          filterByPageIdRange(
            sortUnitsByNew(get(UNIT_DATA, "pages", [])),
            pageId
          )
        );
      } else {
        setPages(sortUnitsByNew(get(UNIT_DATA, "pages", [])));
      }
      setBookId(UNIT_DATA.bookId);
      setDisplayName(get(UNIT_DATA, "displayName", ""));
    }
  }, [UNIT_DATA, pageId]);

  const sortUnitsByNew = (res) => {
    const newUnits = filter(res, ["new", true]).sort(sortUnits);
    const oldUnits = filter(res, (k) => !k.new).sort(sortUnits);
    return [...newUnits, ...oldUnits];
  };
  const onPageInfoChange = (key, value) => {
    const _pgData = cloneDeep(pgData);
    _pgData[key] = value;
    setPgData(_pgData);
  };
  const onCloseModal = () => {
    setUnitModal(false);
    setPgData(null);
    setErrors([]);
  };
  const onCreateOrUpdate = async () => {
    const errors = [];
    let pagesData = pages;
    if (pgData) {
      const index = findIndex(pages, (p) => p.id === pgData?.id);
      if (index >= 0) {
        pagesData = map(pages, (p) => (p.id === pgData.id ? pgData : p));
      } else {
        pagesData = [pgData, ...pages];
      }
      if (
        parseInt(pgData.start) >= parseInt(pgData.finish) ||
        parseInt(pgData.start) == 0
      ) {
        setAlertSakeBar({
          open: true,
          message:
            pgData.start == 0
              ? "Start pageId must be greater then zero "
              : "Start pageId must be less then finish pageId",
          severity: "error",
        });
        return;
      } else if (parseInt(pgData.finish) > pageLengthById) {
        setAlertSakeBar({
          open: true,
          message: `The selected book has only ${pageLengthById} page, and you must select within the available range.`,
          severity: "error",
        });
        return;
      }
    }
    const book = {
      id: editUnit.id,
      pages: pagesData,
      displayName: displayName.replace(/^'+|'+$/g, ""),
      img: cover.replace(/^'+|'+$/g, ""),
      bookId: bookId,
    };
    if (!book.displayName || book.displayName.length == 0) {
      errors.push({
        type: "description_error",
        message: "Book title required.\n",
      });
    }
    if (!book.img || book.img.length == 0) {
      errors.push({ type: "cover_error", message: "Cover image required.\n" });
    }

    setErrors(errors);
    if (errors.length == 0) {
      setLoading(true);
      if (editUnit) {
        const unit = await dispatch(handleUpdateUnits(editUnit.id, book));
        if (has(unit, "id")) {
          setAlertSakeBar({
            open: true,
            message: "Book units updated successfully",
            severity: "success",
          });
          setUnitModal(false);
          setSaveModal(false);
        } else {
          setAlertSakeBar({
            open: true,
            message: "Some thing went wrong!",
            severity: "error",
          });
        }
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const redirectToBook = () => {
    navigate(`/add-book?bookId=${bookId}&pageId=${pgData.start}`);
  };
  const onddUnits = () => {
    let mxId = Math.max(...pages.map((o) => parseInt(o.id)));
    if (isNaN(mxId) || mxId == -Infinity) {
      mxId = 0;
    }
    const item = {
      id: `${mxId + 1}`,
      new: true,
      src: "",
      tags: "",
      start: "",
      finish: "",
      shortName: "",
      categorias: "",
      anécdotas_themes: "",
      ap_themes: "",
      ib_themes: "",
    };
    // setPages([item, ...pages])
    setPgData(item);
    setUnitModal(true);
  };

  const onDelete = async (id) => {
    setDeleteLoader(true);
    const index = findIndex(pages, ["id", id]);
    const oldIndex = findIndex(editUnit.pages, ["id", id]);
    if (oldIndex >= 0) {
      const ePages = cloneDeep(editUnit.pages);
      const eData = cloneDeep(editUnit);
      ePages.splice(oldIndex, 1);
      eData.pages = ePages;
      setEditUnit(eData);
      const unit = await dispatch(handleUpdateUnits(editUnit.id, eData));
      setUnitModal(false);
      setAlertSakeBar({
        open: true,
        message: "Book units deleted successfully",
        severity: "error",
      });
      setSaveModal(false);
    }
    if (index >= 0) {
      const _pgs = cloneDeep(pages);
      _pgs.splice(index, 1);
      setPages(_pgs);
    }
    setDeleteLoader(false);
    setDeleteToggle(false);
  };
  const updateDisabled = useCallback(() => {
    if (!pgData) return true;
    return !!(
      !pgData.start ||
      !pgData.finish ||
      !pgData.shortName ||
      !pgData.src
    );
  }, [pgData]);

  const onClick = (item) => {
    setPgData(item);
    setSelectedItem((prev) => {
      const itemIsSelected = prev.some(
        (existingItem) => existingItem.id === item.id
      );

      // If it's already selected, deselect it (set to empty)
      if (itemIsSelected) {
        return [];
      }

      // Else, select this one only (replacing any previous)
      return [item];
    });
    handleSubmit([item]);
  };

  return (
    <Wrapper>
      <Row>
        <AnimatedText text={displayName} />
      </Row>
      {selection ? null : (
        <Row style={{ marginTop: 16 }}>
          <Col xs={{ span: 24 }} lg={{ span: 10 }}></Col>
          <Col
            xs={{ span: 24 }}
            style={{ display: "flex", flexDirection: "row" }}
            lg={{ span: 14 }}
          >
            <Button
              onClick={onddUnits}
              style={{ minWidth: 150, marginRight: 10 }}
              variant="contained"
              color="primary"
            >
              {" "}
              Add units
            </Button>
            <Button
              onClick={() => setSaveModal(true)}
              style={{ minWidth: 150 }}
              variant="contained"
              color="primary"
            >
              {" "}
              Save
            </Button>
          </Col>
        </Row>
      )}

      <Row style={{ paddingTop: "1%", paddingBottom: 0 }}>
        <Col xs={{ span: 24 }} lg={{ span: 10 }}>
          <ImageContainer>
            <Pages
              src={cover}
              path={`/units/${bookId}`}
              onChange={(item) => {
                setCover(item.url);
              }}
              description={displayName}
              onChangeDescription={(v) => setDisplayName(v)}
              selection={selection}
              hasDescription={false}
            />
          </ImageContainer>
        </Col>
        <Col xs={{ span: 24 }} lg={{ span: 14 }}>
          <CoverSecion overflowItem={pages.length > 12}>
            {chunk(pages, 4).map((bookitem, i) => {
              return (
                <BoxRow key={i + "bookrow"}>
                  {" "}
                  {bookitem.map((item, index) => {
                    return (
                      <Column key={index + i + "bookcol"}>
                        {get(item, "new", false) ? <NewTag>New</NewTag> : null}
                        <BalconCover
                          handleClick={onClick}
                          deleteLoader={deleteLoader}
                          setDeleteLoader={setDeleteLoader}
                          deleteToggle={deleteToggle}
                          setDeleteToggle={setDeleteToggle}
                          onDelete={onDelete}
                          data={item}
                          selection={selection}
                          selectedItem={selectedItem}
                        />
                      </Column>
                    );
                  })}
                </BoxRow>
              );
            })}
          </CoverSecion>
        </Col>
      </Row>
      <Modal
        open={unitModal}
        onClose={() => {}}
        style={{ height: "100%", width: "100%" }}
      >
        <ModalContent>
          <Row style={{ justifyContent: "space-between" }}>
            <TitleText>{editUnit ? "Edit Unit" : "Create Unit"}</TitleText>
            <IconButton onClick={onCloseModal} style={{ padding: 0 }}>
              <Close color="secondary" />
            </IconButton>
          </Row>
          <ModalConfigArea>
            <Row>
              <Col xs={24} lg={12}>
                <PageImagePicker
                  src={get(pgData, "src")}
                  path={`/units/${bookId}`}
                  onChange={(item) => {
                    onPageInfoChange("src", item.url);
                  }}
                  hasDescription={false}
                />
              </Col>
              <Col xs={24} lg={12} style={{ paddingLeft: 10, paddingTop: 10 }}>
                <FormArea style={{ height: "65vh" }}>
                  <Row
                    justify="start"
                    style={{ marginBottom: 10, marginTop: 20 }}
                  >
                    <TextField
                      id="id"
                      name="id"
                      label="Id"
                      InputLabelProps={{ shrink: true, required: true }}
                      type="text"
                      required
                      disabled
                      variant="outlined"
                      onChange={(e) => {}}
                      value={get(pgData, "id")}
                    />
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <Col xs={24} lg={12} style={{ paddingRight: 5 }}>
                      <TextField
                        id="start"
                        name="start"
                        label="start pageId"
                        required={false}
                        InputLabelProps={{ shrink: true }}
                        type="number"
                        variant="outlined"
                        onChange={(e) => {
                          onPageInfoChange("start", e.target.value);
                        }}
                        value={get(pgData, "start")}
                      />
                    </Col>
                    <Col xs={24} lg={12} style={{ paddingLeft: 5 }}>
                      <TextField
                        id="finish"
                        name="finish"
                        label="Finish pageId"
                        required={false}
                        InputLabelProps={{ shrink: true }}
                        type="number"
                        variant="outlined"
                        onChange={(e) => {
                          onPageInfoChange("finish", e.target.value);
                        }}
                        value={get(pgData, "finish")}
                      />
                    </Col>
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <FormControlLabel
                      classes={{
                        root: classes.rootDifFull,
                        label: classes.label,
                      }}
                      control={
                        <Switch
                          classes={{
                            sizeSmall: classes.sizeSmall,
                            checked: classes.checkedSwitch,
                          }}
                          checked={Boolean(get(pgData, "new"))}
                          id="New"
                          onChange={(e) => {
                            onPageInfoChange("new", e.target.checked);
                          }}
                          name="New"
                          color="primary"
                          size="small"
                        />
                      }
                      label="New"
                    />
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <Autocomplete
                      multiple
                      freeSolo
                      id="tags-outlined"
                      options={PAGE_CATEGORY}
                      defaultValue={
                        get(pgData, "tags", "")
                          ? get(pgData, "tags", "").split(",")
                          : []
                      }
                      style={{ width: "100%" }}
                      onChange={(event, value) => {
                        onPageInfoChange("tags", value.join(","));
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          type="text"
                          label="Tags"
                          placeholder="Tags"
                        />
                      )}
                    />
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <TextField
                      id="shortName"
                      name="shortName"
                      label="Display name"
                      required={false}
                      InputLabelProps={{ shrink: true }}
                      type="text"
                      variant="outlined"
                      onChange={(e) => {
                        onPageInfoChange("shortName", e.target.value);
                      }}
                      value={get(pgData, "shortName")}
                    />
                  </Row>

                  <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 20, marginRight: 0, marginLeft: 0 }}
                    className="floatingLabelBG"
                  >
                    <FormControl
                      variant="outlined"
                      className={classes.formControl}
                    >
                      <InputLabel id="Categorias">Categorias</InputLabel>
                      <Select
                        labelId="Categorias"
                        id="Categorias"
                        value={get(pgData, "Categorias", "")}
                        onChange={(v) => {
                          onPageInfoChange("Categorias", v.target.value);
                        }}
                        label="Categorias"
                      >
                        {PAGE_CATEGORY.map((v) => (
                          <MenuItem key={v} value={v}>
                            {v}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <Col xs={24} lg={24}>
                      <Autocomplete
                        multiple
                        freeSolo
                        id="anécdotas-themes-outlined"
                        options={ANÉCDOTAS_THEMES}
                        defaultValue={
                          get(pgData, "anécdotas_themes", "")
                            ? get(pgData, "anécdotas_themes", "").split(",,")
                            : []
                        }
                        style={{ width: "100%" }}
                        onChange={(event, value) => {
                          onPageInfoChange(
                            "anécdotas_themes",
                            value.join(",,")
                          );
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            label="Anécdotas Themes"
                            placeholder="Anécdotas Themes"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <Col xs={24} lg={24}>
                      <Autocomplete
                        multiple
                        freeSolo
                        id="ap-themes-outlined"
                        options={AP_THEME}
                        defaultValue={
                          get(pgData, "ap_themes", "")
                            ? get(pgData, "ap_themes", "").split(",")
                            : []
                        }
                        style={{ width: "100%" }}
                        onChange={(event, value) => {
                          onPageInfoChange("ap_themes", value.join(","));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            label="AP Themes"
                            placeholder="Ap Themes"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  {/* ib themes */}
                  <Row justify="start" style={{ marginTop: 20 }}>
                    <Col xs={24} lg={24}>
                      <Autocomplete
                        multiple
                        freeSolo
                        id="ib-themes-outlined"
                        options={IB_Theme}
                        defaultValue={
                          get(pgData, "ib_themes", "")
                            ? get(pgData, "ib_themes", "").split(",")
                            : []
                        }
                        style={{ width: "100%" }}
                        onChange={(event, value) => {
                          onPageInfoChange("ib_themes", value.join(","));
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            type="text"
                            label="IB Themes"
                            placeholder="IB Themes"
                          />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row gutter={[16, 24]} className="durDateSpc">
                    <Col span={24}>
                      <DateTimePicker
                        id="StartFrom"
                        label="Start Date"
                        inputVariant="outlined"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        defaultValue={null}
                        format="MM-dd-yyyy hh:mm a"
                        initialFocusedDate={moment().toString()}
                        strictCompareDates
                        value={get(pgData, "startDate")}
                        onChange={(e) => {
                          onPageInfoChange("startDate", e.toISOString());
                        }}
                      />
                    </Col>
                    <Tag height={20}>
                      <Star
                        style={{
                          height: "12px",
                          margin: "-1px 4px 0px 0px",
                          width: "12px",
                        }}
                      />{" "}
                      NOTE
                    </Tag>
                    <Note>
                      This will take effect after the given date and time.
                    </Note>
                  </Row>
                </FormArea>
                {bookErrors.length > 0 ? (
                  <Row
                    style={{
                      marginTop: 10,
                      marginRight: 0,
                      marginLeft: 0,
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    {bookErrors.map((v) => (
                      <Typography
                        variant="subtitle2"
                        key={v.type}
                        style={{ whiteSpace: "pre-wrap" }}
                        color="error"
                      >
                        * {get(v, "message")}
                      </Typography>
                    ))}
                  </Row>
                ) : null}
                <Row
                  gutter={[24, 24]}
                  style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
                >
                  <Button
                    fullWidth
                    onClick={onCreateOrUpdate}
                    disabled={updateDisabled()}
                    variant="contained"
                    color="primary"
                  >
                    {loading ? <Loading white size={15} /> : null}
                    {editUnit ? "Update" : "Create"}
                  </Button>
                </Row>
                <Row
                  gutter={[24, 24]}
                  style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
                >
                  <Button
                    fullWidth
                    onClick={redirectToBook}
                    variant="contained"
                    color="primary"
                  >
                    Open book
                  </Button>
                </Row>
              </Col>
            </Row>
          </ModalConfigArea>
        </ModalContent>
      </Modal>
    </Wrapper>
  );
};


const mapStateToProps = (state) => ({
  currentClass: state.currentClass,
  currentUser: state.currentUser,
  tipsBook: state.tipsBook,
  classUsers: state.classUsers,
  classActivities: state.classActivities,
  classQuizzes: state.classQuizzes,
  submissions: state.submissions,
  booksAllList: state.booksAllList,
});

export default connect(mapStateToProps, null)(UnitModal);